<template>
    <div id="ii-chapters">
        <div class="col-12">
            <input-checkbox :text="$t('Display chapter title')" v-model="interactiveImage.display_chapters_titles" @change="interactiveImage.patch('display_chapters_titles')" class="no-border"/>
        </div>
        <div class="hr"></div>
        <div class="row wrap">
            <draggable class="chapters-item" v-model="interactiveImage.chapters" @change="orderChange" handle=".grip" ghost-class="ghost" :class="{'editing': interactiveImage.chapterHasEditing()}">
                <InteractiveImage_Chapter
                    v-for="(chapter,key) in interactiveImage.chapters"
                    :class="{select:interactiveImage.chapterIsActive(key) && !interactiveImage.chapterHasEditing()}"
                    :key="chapter.pk"
                    :chapter="chapter"
                    :chapter-count="interactiveImage.chapters.length"
                    :edit="interactiveImage.chapterIsEditing(key)"
                    :show-title="interactiveImage.display_chapters_titles"
                    @edit="edit(key)"
                    @select="select(key)"
                    @remove="remove"
                />
            </draggable>
        </div>
        <div class="row wrap">
            <div class="col-12 p-1">
                <btn icon @click="add">
                    <i class="fal fa-plus"></i>
                    <tooltip :text="$t('Add new chapter')" delay="0.5s">
                        {{$t('Add new chapter')}}
                    </tooltip>
                </btn>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable     from 'vuedraggable'
    import InteractiveImage_Chapter from "@/views/interactives-images/InteractiveImage_Chapter";
    import {interactiveImage} from "@/class/interactive-image/interactiveImage";
    import Btn from "@/modules/buttons/btn";
    import InputCheckbox from "@/modules/input/input-checkbox";
    import Tooltip from "@/modules/tooltip";

    export default {
        name: "InteractiveImage_Chapters",
        components: {Tooltip, Btn, InteractiveImage_Chapter, draggable,InputCheckbox},
        props:{
            interactiveImage:{type:Object,default:() => new interactiveImage()},
            events:{type:Object},
        },
        methods: {
            orderChange(val){
                this.interactiveImage.chapters.map((chapter,key) => {
                    chapter.order = key;
                })
                this.interactiveImage.saveChapters(false);
            },
            add(){
                this.interactiveImage.chapterAdd()
            },
            async remove(chapter){
                
                await chapter.delete()
    
                if(this.interactiveImage.chapterGetCurrent() === chapter){
                    let key = this.interactiveImage.currentChapterKey > 0 ? this.interactiveImage.currentChapterKey - 1 : 0
                    this.interactiveImage.chapterSetActive(key)
                }
    
                this.interactiveImage.chapters = this.interactiveImage.chapters.filter((c) => c !== chapter)
                
                
            },
            select(key){
                if(this.interactiveImage.chapterHasEditing()){
                    return
                }
                this.interactiveImage.chapterSetActive(key,false)
            },
            edit(key){
                if(this.interactiveImage.chapterGet(key).isEditing){
                    return this.interactiveImage.chapterGet(key).unedit()
                }
                this.interactiveImage.chapterSetActive(key,false)
                this.interactiveImage.chapterEdit(key)
            }
        },
    }
</script>